import { render, staticRenderFns } from "./batchRemarkSetting.vue?vue&type=template&id=32b7f0ac&scoped=true&"
import script from "./batchRemarkSetting.vue?vue&type=script&lang=js&"
export * from "./batchRemarkSetting.vue?vue&type=script&lang=js&"
import style0 from "./batchRemarkSetting.vue?vue&type=style&index=0&id=32b7f0ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b7f0ac",
  null
  
)

export default component.exports